export default "__VITE_ASSET__837c01f0__"